export default __webpack_public_path__ + "static/media/blog-img222.b957582c.jpg";